// extracted by mini-css-extract-plugin
export var fullGrid = "_27-3";
export var pdpPreviewContainer = "_27-1";
export var previewContainer = "_27-0";
export var togglePreviewContainer = "_27-2";